import React, { useState } from "react";
import { useUpdateFirmMutation } from "../../../redux/reduxQuery/firmApi";
import { useMutationWrapper } from "../../../common/api";
import { useNavigate } from "react-router-dom";
import LawFirmForm from "./components/LawFirmForm";

interface EditGeneralInfoProps {
  firmData: any;
}

const EditGeneralInfo: React.FC<EditGeneralInfoProps> = ({ firmData }) => {
  const [updateLawFirm] = useUpdateFirmMutation();
  const [isProcessing, setIsProcessing] = useState(false);
  let navigate = useNavigate();

  const mutateFirm = useMutationWrapper(
    updateLawFirm,
    (data) => `${data.name} was updated successfully`,
    () => navigate("/admin/law-firms")
  );

  const handleFormSubmit = async (data: any) => {
    setIsProcessing(true);
    try {
      await mutateFirm({ ...firmData, ...data, state: data.state });
    } finally {
      setIsProcessing(false);
    }
  };

  const handleFormCancel = (
    isDirty: boolean,
    reset: (values?: any) => void
  ) => {
    if (isDirty) {
      reset(firmData);
    }
  };

  return (
    <LawFirmForm
      initialData={firmData}
      onFormSubmit={handleFormSubmit}
      onFormCancel={handleFormCancel}
      submitButtonText="Save Changes"
      isProcessing={isProcessing}
      renderButtonsExternal={false}
    />
  );
};

export default EditGeneralInfo;
